import {IImportHrFile} from '../../index';
import {global} from '../../appContext';
import {IPageShellHeaderActions} from '../page-shell/pageShellHeaderActions';
import {nsFa} from '../fa/fn';
import i = nsFa.i;

/** Import history actions for the page heading: send messages next to the tabs. */
export function buildImportHistoryActions(importHrFile: IImportHrFile): IPageShellHeaderActions {
    return {
        quick: [
            {
                icon: 'fa-mail-bulk',
                label: 'send message|p',
                description: () => 'send message|p',
                enabled: () => !!importHrFile.synccyclesteps?.length,
                onClick: () => {
                    global.dialogManager.addComponent({
                        title: `${i('fa-mail-bulk')} ((send message|p)) [${importHrFile.started}]`,
                        content: {
                            name: 'component/messages/dialog/send-messages-by-message-flows',
                            params: {importHrFileId: importHrFile.id},
                        },
                        fullWidth: true,
                    });
                },
            },
        ],
        more: [],
    };
}
